export default __webpack_public_path__ + "static/partnerIcon16-8b6ce8f3753812488a90d4528ac6636c.svg";